module.exports = __webpack_public_path__ + "img/freeGet.23be2749.png";